import React, { memo, useEffect } from "react";
import Button from "../button";
import styles from "./questionsType.module.scss";
import classnames from 'classnames';
import { useDispatch } from "react-redux";
import { setSkippedQuestion } from "../../redux/reducers/questionReducer/questionReducer";

let timer;

interface ConfirmButtonProps {
  isComplete: boolean,
  isConfirm: boolean,
  handleSkip: () => void,
  handleConfirm: () => void,
  hideConfirm?: boolean,
  hideSkip?: boolean,
  className?: string,
  isMobile: boolean,
  disabled: boolean,
  nextStep?: boolean,
  currentQuestion?: number | null,
}

export const ConfirmButton: React.FC<ConfirmButtonProps> = memo(
  ({ 
    isComplete,
    isConfirm,
    handleConfirm,
    handleSkip,
    hideConfirm,
    hideSkip,
    className,
    isMobile,
    disabled,
    nextStep,
    currentQuestion,
   }) => {
    const dispatch = useDispatch();

    const handleTrigger = (event: () => void) => {
        if (nextStep) {
          document.dispatchEvent(new CustomEvent('scroll_to_zero', {
            detail: {
              scroll: true,
            }
          }));
        } else {
          timer = setTimeout(() => {
            document.dispatchEvent(new CustomEvent('scroll_to_zero', {
              detail: {
                scroll: true,
              }
            }));
          }, 800);
        }
      event();
    }

    const dispatchSkippedQuestion = () => {
      let correctQuestion = currentQuestion || 1;
      dispatch(setSkippedQuestion(`q${correctQuestion}_1`))
      handleSkip();
    }

    useEffect(() => {
      return () => clearTimeout(timer);
    }, []);

    return (
      <div
        className={
          isMobile
            ? classnames(styles.buttonGroup, styles.mobileGroup, className)
            : classnames(styles.buttonGroup, className)
        }
      >
        {
          !hideSkip
          ? (
            <Button
              onClick={() => handleTrigger(dispatchSkippedQuestion)}
              className={classnames(styles.skipButton, isMobile ? styles.mobile : '')}
              disabled={disabled}
            >
              {`Skip >`}
            </Button>
          )
          : null
        }
        {
          !hideConfirm
          ? (
            <Button
              onClick={() => handleTrigger(handleConfirm)}
              className={classnames(styles.buttonNext, isMobile ? styles.mobile : '')}
              buttonStyles={styles.buttonNextWrapper}
              disabled={disabled}
            >
              {isComplete || isConfirm ? "GO TO NEXT QUESTION" : "CONFIRM"}
            </Button>
          )
          : null
        }
      </div>
    );
  }
);
